package uk.co.nickthecoder.kyd.appearance

import uk.co.nickthecoder.kyd.Actor

/**
 * Implemented by anything that can provide an [Appearance].
 *
 * [Pose] and [Graphic] return themselves.
 * [NinePatch] returns a [NinePatchAppearance].
 *
 */
interface WithAppearance {

    /**
     * [Pose] and [Graphic] return themselves.
     * [NinePatch] returns a [NinePatchAppearance].
     *
     * Use this to create an appearance for a new [Actor].
     * However, if you wish to change the appearance of an actor, use [appearanceForActor] instead
     * (or [applyToActor]).
     */
    fun appearance(): Appearance

    /**
     * Creates an Appearance with the same tint.
     * Also, if the new appearances is [StretchableAppearance] then it will have the same
     * bounds as the previous appearance.
     */
    fun appearanceForActor(actor: Actor): Appearance


    /**
     * Set the actor's appearance.
     *
     * Equivalent to :
     *
     *     actor.appearance = this.appearanceForActor( actor )
     */
    fun applyToActor(actor: Actor) {
        actor.appearance = appearanceForActor(actor)
    }

}
